export const SET_USER = 'SET_USER';
export const SET_AUTHLOADED = 'SET_AUTHLOADED';